import React from 'react';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SettingField from 'components/Fields/ReduxForm/SettingField';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import WarningMessage from 'components/WarningMessage/WarningMessage';
import classNames from 'classnames';
import withFeatureFlags from 'hocs/withFeatureFlags';
import isExperienceComplete from 'selectors/isExperienceComplete';
import { fetchExperiences, completeExperience } from 'reducers/ftue/actions';
import { FTUE_TAX_CONFIG_TOUR } from 'reducers/ftue/ftueKeys';
import { openTaxConfiguration as openTaxConfigurationClevertap } from 'clevertap/settings/checkout';
import TaxConfigurationFtue from '../TaxConfigurationFtue';
import styles from './CheckoutForm.css';
import TaxConfigurationModal from '../TaxConfigurationModal';

class CheckoutForm extends React.Component {
  static FORM_NAME = 'checkout';

  state = {
    showTaxConfigurationModal: false,
    clickedConfirmButton: false,
  };

  render() {
    const {
      enableTaxConfiguration,
      settingOutlets,
      outlets,
      onTourComplete,
      showFtue,
    } = this.props;

    const {
      showTaxConfigurationModal,
      hasTaxConfigurationChanged,
    } = this.state;

    return (
      <form id="checkout-form" onSubmit={this.props.handleSubmit}>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className={styles.header}>Tax and Gratuity SETTINGS</div>
              </div>
            </div>
            <div className={`${styles['form-group']} row`}>
              <div className="col-lg-9 col-md-9 col-sm-6">Enable Tax</div>
              <div className="col-lg-3 col-md-3 col-sm-6">
                <span className={styles.switchbox}>
                  <Field component={SwitchField} name="tax" type="checkbox" />
                </span>
              </div>
            </div>
            <div className={`${styles['form-group']} row`}>
              <div className="col-lg-9 col-md-9 col-sm-6">Enable Gratuity</div>
              <div className="col-lg-3 col-md-3 col-sm-6">
                <span className={styles.switchbox}>
                  <Field
                    component={SwitchField}
                    name="gratuity"
                    type="checkbox"
                  />
                </span>
              </div>
            </div>
            <div className={`${styles['form-group']} row`}>
              <div className="col-sm-12">
                <div className="col-sm-12 no-padding">
                  <Field
                    component="select"
                    name="includeGratuityTax"
                    className="form-control"
                  >
                    <option value="false">
                      Add Tax and Gratuity to Item Price
                    </option>
                    <option value="true">
                      Include Tax and Gratuity to Item Price
                    </option>
                  </Field>
                </div>
              </div>
            </div>

            {enableTaxConfiguration && (
              <div
                className={classNames(
                  styles['form-group'],
                  'row',
                  'taxcon-set-outlets-section'
                )}
              >
                <div className="col-sm-9 col-xs-8 mb-5">
                  <span className={styles['form-checkout-subtitle']}>
                    Outlet's Tax-Discount Preference
                  </span>
                  <p className={styles['form-checkout-description']}>
                    Settings for applying tax before/after discount. Gratuity
                    will follow tax setting, whether it is put before or after
                    discount
                  </p>
                </div>
                <div className="col-sm-3 col-xs-auto mt-10px">
                  <span className={styles.buttonbox}>
                    <button
                      type="button"
                      className={classNames(
                        styles.setOutletButton,
                        'btn btn-default'
                      )}
                      onClick={this.handleSetOutletsButtonClick}
                    >
                      Set Outlets
                    </button>
                  </span>
                </div>
                {hasTaxConfigurationChanged && (
                  <div
                    className={classNames(
                      'col-xs-12',
                      styles.formDetectChanges
                    )}
                  >
                    <i>
                      *Changes on this setting detected. Click save below to
                      complete.
                    </i>
                  </div>
                )}
                <div className="col-xs-12">
                  <WarningMessage
                    message="This feature currently only works on iOS (v26.5 the least), coming soon on Android"
                    iconStyle="circle"
                  />
                </div>
              </div>
            )}
            <hr />
            <div className="row">
              <div className="col-sm-12">
                <div className={styles.header}>Rounding Settings</div>
              </div>
            </div>
            <div className={`${styles['form-group']} row`}>
              <div className="col-lg-9 col-md-9 col-sm-6">Enable Rounding</div>
              <div className="col-lg-3 col-md-3 col-sm-6">
                <span className={styles.switchbox}>
                  <Field
                    component={SwitchField}
                    name="rounding"
                    type="checkbox"
                  />
                </span>
              </div>
            </div>
            {this.props.roundingChecked && this.props.roundingSettingsOptions && (
              <div>
                <div className={`${styles['form-group']} row`}>
                  <div
                    className="col-lg-4 col-md-4 col-sm-6"
                    style={{ paddingTop: '7px', width: '185px' }}
                  >
                    Rounding Digits
                    <span style={{ paddingLeft: '47px' }}>:</span>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6">
                    <span>
                      <Field
                        component="select"
                        name="roundingOption"
                        className="form-control"
                      >
                        {this.props.roundingSettingsOptions.map(opt => (
                          <option value={opt.id} key={opt.id}>
                            {opt.display_name}
                          </option>
                        ))}
                      </Field>
                    </span>
                  </div>
                </div>
                <div className={`${styles['form-group']} row`}>
                  <div
                    className="col-lg-4 col-md-4 col-sm-6"
                    style={{ paddingTop: '7px', width: '185px' }}
                  >
                    Rounding Down below
                    <span style={{ paddingLeft: '5px' }}>:</span>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4">
                    <span>
                      <Field
                        name="roundingDownBelow"
                        component={SettingField}
                        positiveNumberOnly
                        maxLength={this._maxDigitLength()}
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div>
              {this.props.roundingChecked &&
                this._constructRoundingExampleMessage()}
            </div>
            <hr />
            <div>
              <div className="row">
                <div className="col-sm-12">
                  <div className={styles.header}>STOCK LIMIT</div>
                </div>
              </div>
              <div className={`${styles['form-group']} row`}>
                <div className={`col-lg-9 col-md-9 col-sm-6 col-xs-9 mb-5`}>
                  <span className={styles['form-checkout']}>
                    Enable stock limit
                  </span>
                  <p className={`${styles['form-checkout-description']}`}>
                    When turned on, cashiers are not able to sell items with
                    stock under or equal to 0.
                  </p>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-3 mt-10px">
                  <span className={styles.switchbox}>
                    <Field
                      component={SwitchField}
                      name="isStockLimit"
                      type="checkbox"
                    />
                  </span>
                </div>
                {this.props.stockLimitChecked ? (
                  <div>
                    <div
                      className={`col-lg-9 col-md-9 col-sm-6 col-xs-9 ${
                        styles['form-section-container']
                      }`}
                    >
                      <span className={styles['form-checkout']}>
                        Allow Override
                      </span>
                      <p className={`${styles['form-checkout-description']}`}>
                        When turned on, cashiers will be able to sell items with
                        stock under or equal to 0. This feature will act as
                        warning.
                      </p>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-3 mt-30px">
                      <span className={styles.switchbox}>
                        <Field
                          component={SwitchField}
                          name="isStockOverride"
                          type="checkbox"
                        />
                      </span>
                    </div>
                  </div>
                ) : null}
              </div>
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className={styles.header}>Other Settings</div>
              </div>
            </div>
            <div className={`${styles['form-group']} row`}>
              <div className="col-lg-9 col-md-9 col-sm-6">Track Server</div>
              <div className="col-lg-3 col-md-3 col-sm-6">
                <span className={styles.switchbox}>
                  <Field
                    component={SwitchField}
                    name="trackServer"
                    type="checkbox"
                  />
                </span>
              </div>
            </div>
            <hr />
            <div className={`${styles['form-group']} row`}>
              <div className="col-sm-12">
                <span className="pull-right">
                  <button
                    type="submit"
                    className="btn btn-primary taxcon-ftue-save-button"
                  >
                    Save
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        {enableTaxConfiguration && showTaxConfigurationModal && outlets && (
          <TaxConfigurationModal
            onCancel={this.handleCancelTaxConfig}
            onConfirm={this.handleConfirmTaxConfig}
            settingOutlets={settingOutlets}
            outlets={outlets}
            isShowAnimation={!showFtue}
          />
        )}
        {enableTaxConfiguration && showFtue && (
          <TaxConfigurationFtue
            isModalOpen={showTaxConfigurationModal}
            onRequestModalOpen={this.handleSetOutletsButtonClick}
            onRequestModalClose={this.handleCancelTaxConfig}
            onCompletion={onTourComplete}
          />
        )}
      </form>
    );
  }

  handleSetOutletsButtonClick = () => {
    this.setState({ showTaxConfigurationModal: true });
    openTaxConfigurationClevertap();
  };

  handleCancelTaxConfig = () => {
    this.setState({ showTaxConfigurationModal: false });
  };

  handleConfirmTaxConfig = assignedOutlets => {
    const { changeOutletsField } = this.props;
    this.setState({
      showTaxConfigurationModal: false,
      hasTaxConfigurationChanged: true,
    });
    changeOutletsField('checkout', 'outlets', assignedOutlets);
  };

  _constructRoundingExampleMessage = () => {
    const roundingOption = parseInt(this.props.roundingOption);
    const roundingDownBelow = this.props.roundingDownBelow
      ? parseInt(this.props.roundingDownBelow)
      : 0;
    const basicAmount = 10000;
    let roundUpAmount = 10000;
    if (roundingOption === 1) {
      roundUpAmount = 11000;
    } else if (roundingOption === 2) {
      roundUpAmount = 10100;
    } else if (roundingOption === 3) {
      roundUpAmount = 10010;
    }

    return `${basicAmount +
      roundingDownBelow} is ${basicAmount}; ${basicAmount +
      roundingDownBelow +
      1} is ${roundUpAmount}`;
  };

  _maxDigitLength = () => {
    const roundingOption = parseInt(this.props.roundingOption);
    if (roundingOption === 1) {
      return 3;
    }
    if (roundingOption === 2) {
      return 2;
    }
    if (roundingOption === 3) {
      return 1;
    }
  };
}

const validate = values => {
  const errors = {};
  const roundingOption = parseInt(values.roundingOption);
  const roundingDownBelow = parseInt(values.roundingDownBelow);

  if (roundingOption === 1 && roundingDownBelow > 999) {
    errors.roundingDownBelow = 'Maximum allowed value is 999';
  } else if (roundingOption === 2 && roundingDownBelow > 99) {
    errors.roundingDownBelow = 'Maximum allowed value is 99';
  } else if (roundingOption === 3 && roundingDownBelow > 9) {
    errors.roundingDownBelow = 'Maximum allowed value is 9';
  }

  if (roundingOption && !roundingDownBelow) {
    errors.roundingDownBelow = 'Minimum value is 1';
  }

  return errors;
};

CheckoutForm.propTypes = {
  onSubmit: PropTypes.func,
};

CheckoutForm.defaulProps = {
  showFtue: false,
};

const mapForm = {
  form: CheckoutForm.FORM_NAME,
  validate,
};

const selector = formValueSelector(CheckoutForm.FORM_NAME);

function mapStateToProps(state) {
  const { setting, outlets } = state.setting.checkout;
  return {
    roundingSettingsOptions: setting.rounding_settings_options,
    roundingChecked: selector(state, 'rounding'),
    stockLimitChecked: selector(state, 'isStockLimit'),
    roundingDownBelow: selector(state, 'roundingDownBelow'),
    roundingOption: selector(state, 'roundingOption'),
    settingOutlets: selector(state, 'outlets'),
    outlets,
    showFtue: !isExperienceComplete(state, FTUE_TAX_CONFIG_TOUR),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeOutletsField: (formName, fieldName, value) =>
      dispatch(change(formName, fieldName, value)),
    onLoad: () => {
      dispatch(fetchExperiences());
    },
    onTourComplete: () => dispatch(completeExperience(FTUE_TAX_CONFIG_TOUR)),
  };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps,
  null
)(reduxForm(mapForm)(CheckoutForm));

const mapFlagsToProps = flags => ({
  enableTaxConfiguration: flags.enableTaxConfiguration,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
